"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _moment = _interopRequireDefault(require("moment"));

var _shoutoutThemesEnterprise = require("@shoutout-labs/shoutout-themes-enterprise");

var _default = function _default(props) {
  var value = props.value,
      setValue = props.setValue,
      config = props.config,
      valueFormat = props.valueFormat,
      readonly = props.readonly;

  var onChange = function onChange(date) {
    if (date) {
      setValue((0, _moment["default"])(date).format(valueFormat));
    } else {
      setValue(undefined);
    }
  };

  return /*#__PURE__*/_react["default"].createElement(_shoutoutThemesEnterprise.FormDate, {
    date: value ? (0, _moment["default"])(value).toDate() : undefined,
    disabled: readonly,
    onChange: onChange,
    dateDisplayFormat: valueFormat,
    size: "sm"
  });
};

exports["default"] = _default;